import { render, staticRenderFns } from "./TextOverImage.vue?vue&type=template&id=b968c87a&scoped=true"
import script from "./TextOverImage.vue?vue&type=script&lang=js"
export * from "./TextOverImage.vue?vue&type=script&lang=js"
import style0 from "./TextOverImage.vue?vue&type=style&index=0&id=b968c87a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b968c87a",
  null
  
)

export default component.exports